import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest.js';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';

var printTov = {
    methods: {
        async printTOV() {
            this.spinning = true;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;
            const childDocs = await this.fetchChildDocuments(documentDetails.id);
            documentDetails.child_doc = childDocs;

            // console.log("childDocs", childDocs);
            // console.log("tableData", tableData);
            // console.log("documentDetails", documentDetails);

            // create PDF in landscape
            const doc = new jsPDF('l', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const userName = secureStorage.getItem("userName");
            let xLeftKey = 40;

            function formatNumber(val) {
                if (!val) return '0.00';
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(val);
            }

            function formatDate(date, labelIfMissing = '') {
                if (!date) {
                    return labelIfMissing;
                }
                return moment(date).isValid() ? moment(date).format('MM/DD/YYYY') : labelIfMissing;
            }

            function formatDateTime(date, labelIfMissing = '') {
                if (!date) {
                    return labelIfMissing;
                }
                return moment(date).isValid() ? moment(date).format('MM/DD/YYYY HH:mm:ss') : labelIfMissing;
            }

            // header
            doc.setFontSize(14);
            doc.setFontStyle("bold");
            doc.text('TRANSFER ORDER VERIFICATION', xLeftKey, 30);

            doc.setFontSize(10);
            doc.setFontStyle("normal");
            doc.text(`Company: ${documentDetails.company_name || ''}`, xLeftKey, 55);
            doc.text(`Supplying Branch: ${documentDetails.source_site_name || ''}`, xLeftKey, 70);
            doc.text(`Requesting Branch: ${documentDetails.target_site_name || ''}`, xLeftKey, 85);
            doc.text(`Resolution: ${documentDetails.resolution || ''}`, xLeftKey, 100);

            const remarksText = `Remarks: ${documentDetails.remark || ''}`;
            const remarksMaxWidth = pageWidth - xLeftKey - 310;
            const wrappedRemarks = doc.splitTextToSize(remarksText, remarksMaxWidth);
            doc.text(wrappedRemarks, xLeftKey, 115);

            doc.setFontStyle("bold");
            doc.text("STI CAS #:", pageWidth - 250, 55);

            doc.setFontStyle("normal");
            doc.text(`${documentDetails.cas_no || ''}`, pageWidth - 191, 55);

            doc.setFontStyle("normal");
            doc.text(`Posting Date: ${formatDate(documentDetails.posted_at, 'Not posted')}`, pageWidth - 250, 70);
            doc.text(`Purpose: ${documentDetails.purpose_id.label || ''}`, pageWidth - 250, 85);
            doc.text(`Status: ${documentDetails.status || ''}`, pageWidth - 250, 100);
            // wrap text if too long
            if (childDocs) {
                const childText = `Child Document: ${childDocs}`;
                const maxWidth = 200;
                const wrappedChildText = doc.splitTextToSize(childText, maxWidth);
                doc.text(wrappedChildText, pageWidth - 250, 115);
            } else {
                doc.text(`Child Document: `, pageWidth - 250, 115);
            }

            // table
            const tableColumns = [
                { header: 'LINE NO.', dataKey: 'line_no' },
                { header: 'BARCODE', dataKey: 'barcode' },
                { header: 'DESCRIPTION', dataKey: 'product_name' },
                { header: 'BRAND', dataKey: 'brand_name' },
                { header: 'STO QTY', dataKey: 'sto_qty' },
                { header: 'STI QTY', dataKey: 'sti_qty' },
                { header: 'VARIANCE', dataKey: 'variance_quantity' },
                { header: 'REMARKS', dataKey: 'remarks' },
            ];

            const tableBody = tableData.map((row, index) => ({
                line_no: index + 1,
                barcode: row.barcode,
                product_name: row.product_name,
                brand_name: row.brand_name,
                sto_qty: row.sto_qty,
                sti_qty: row.sti_qty,
                variance_quantity: row.variance_quantity,
                remarks: row.remarks
            }));

            doc.autoTable({
                columns: tableColumns,
                body: tableBody,
                startY: 155,
                styles: { fontSize: 9 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                columnStyles: {
                line_no: { halign: 'left', cellWidth: 50 },
                barcode: { halign: 'left', cellWidth: 100 },
                description: { halign: 'center', cellWidth: 120 },
                brand: { halign: 'center', cellWidth: 100 },
                count_qty: { halign: 'left', cellWidth: 60 },
                freeze_qty: { halign: 'left', cellWidth: 60 },
                variance: { halign: 'left', cellWidth: 60 },
                remarks: { halign: 'center', cellWidth: 80 },
                },
                margin: { left: 40, right: 40 },
                tableLineWidth: 0.5,

                // footer
                didDrawPage: (data) => {
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const pageWidth = doc.internal.pageSize.getWidth();

                    doc.setFontSize(10);
                    doc.setFontStyle("normal");
                    doc.text(`Created By: ${documentDetails.created_by || ''}`, 40, pageHeight - 40);
                    doc.text(`Creation Date: ${moment(documentDetails.created_at).format('MM/DD/YYYY HH:mm:ss')}`, 40, pageHeight - 25);
                    doc.text(`Posted By: ${documentDetails.posted_by || userName}`, pageWidth - 250, pageHeight - 40);
                    doc.text(`Posting Date: ${formatDateTime(documentDetails.posted_at, 'Not posted')}`, pageWidth - 250, pageHeight - 25);              

                    // const pageCount = doc.internal.getNumberOfPages();
                    // doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 40, pageHeight - 10, { align: 'right' });
                }
            });

            let pdfWindow = window.open(doc.output('bloburl'), '_blank');

            this.spinning = false;
        },
        async fetchChildDocuments(documentId) {
            try {
                const response = await HTTPRequest.getRequest(this.endPoint + '/documents/get_related_document?document_id=' + documentId, null, null);

                console.log("response", response);

                if (response && response.grand_children) {
                    // console.log("response.grand_children", response.grand_children);
                    return response.grand_children.map(child => child.cas_no).join(', ');
                }
                return '';
            } catch (error) {
                console.error("Failed to fetch child documents", error);
                return '';
            }
        },
    }  
};

export default printTov;
